import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import { Box, MenuItem, Paper, Popper } from '@mui/material';
import React from 'react';
import { Row } from 'spw-shared/globalComponents';
import { colors } from 'spw-theme';
import styled from 'styled-components';

const ContentContainer = styled(Paper)`
  padding: 12px 0px;
  font-size: 12px;
  box-sizing: border-box;
  min-width: 190px;
  z-index: 200;
  background-color: white;

  && {
    text-align: left;
    .error-title {
      font-style: normal;
      line-height: 16px;
      color: ${colors.red};
    }
    .MuiMenuItem-root {
      font-size: 12px;
    }
  }
`;

type Props = {
  anchorEl: HTMLElement;
  onRound: (e: React.MouseEvent, direction: 'up' | 'down') => void;
};

const QuantityRoundingPopup = ({ onRound, anchorEl }: Props) => {
  return (
    <Popper
      sx={{
        zIndex: 200,
      }}
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      disablePortal
      keepMounted
      placement="right-start"
      modifiers={[
        {
          name: 'offset',
          options: {
            offset: [0, 7],
          },
        },
      ]}
    >
      <ContentContainer>
        <Box className="error-title" mb={0.5} padding="0px 12px">
          QTY should be a whole number
        </Box>

        <MenuItem
          onMouseDown={(e) => onRound(e, 'up')}
          sx={{ paddingLeft: 1.5, paddingRight: 1.5 }}
        >
          <Row alignItems="center">
            <ArrowUpward htmlColor={colors.mainBlue} fontSize="small" />
            <Box ml={0.5}>Round Up</Box>
          </Row>
        </MenuItem>

        <MenuItem
          onMouseDown={(e) => onRound(e, 'down')}
          sx={{ paddingLeft: 1.5, paddingRight: 1.5 }}
        >
          <Row alignItems="center">
            <ArrowDownward htmlColor={colors.mainBlue} fontSize="small" />
            <Box ml={0.5}>Round Down</Box>
          </Row>
        </MenuItem>
      </ContentContainer>
    </Popper>
  );
};

export default QuantityRoundingPopup;
